// Keep in sync with project's & publication's Main.country.config.options

const COUNTRIES = {
  be: {
    name: 'Belgium',
    flag: '🇧🇪'
  },
  ch: {
    name: 'Switzerland',
    flag: '🇨🇭'
  },
  de: {
    name: 'Germany',
    flag: '🇩🇪'
  },
  es: {
    name: 'Spain',
    flag: '🇪🇸'
  },
  fr: {
    name: 'France',
    flag: '🇫🇷'
  },
  nl: {
    name: 'Netherlands',
    flag: '🇳🇱'
  },
  pl: {
    name: 'Poland',
    flag: '🇵🇱'
  },
  se: {
    name: 'Sweden',
    flag: '🇸🇪'
  },
  uk: {
    name: 'United Kingdom',
    flag: '🇬🇧'
  }
};

export default COUNTRIES;
